<script setup>
import {ref, onMounted} from 'vue'

const props = defineProps({
    oldValue: Number,
    newValue: Number
})

const btn1Text = ref('')
const btn1Class = ref('')
const btn2Text = ref('')
const btn2Class = ref('')

// created logic translated to setup (runs before component mount)
if (!props.oldValue) {
    btn1Text.value = 'Unpublished'
    btn1Class.value = 'btn-danger'

    btn2Text.value = 'Published'
    btn2Class.value = 'btn-success'
} else {
    btn1Text.value = 'Published'
    btn1Class.value = 'btn-success'

    btn2Text.value = 'Unpublished'
    btn2Class.value = 'btn-danger'
}
</script>

<template>
    <div class="d-flex align-items-center">
        <button :class="btn1Class" class="me-1 btn btn-sm" type="button">
            {{ btn1Text }}
        </button>

        <i class="me-1 bi-chevron-right"/>

        <button :class="btn2Class" class="btn btn-sm" type="button">
            {{ btn2Text }}
        </button>
    </div>
</template>